import emissions from '@/api/modules/emissions';
import articles from '@/api/modules/articles';

export default {
  emissions,
  articles,
};
